// @ts-nocheck
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Helmet } from 'react-helmet-async';

//tabs
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

// Accordion
import Accordion from 'react-bootstrap/Accordion';

//Smooth Scroll
import { Link } from 'react-scroll';

//downloads
import download from 'downloadjs';

import React from 'react';
import { useState, useEffect } from 'react';

//ヘッダー
import Header from '../../component/page_parts/header';

// フッター
import Footer from '../../component/page_parts/footer';

//検索
import Search from '../../component/page_parts/keiri_content/search';

//モーダル
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';

// レイアウト
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

//icon
import * as Icon from 'react-bootstrap-icons';
import { Hits, InstantSearch } from 'react-instantsearch-hooks-web';

//scrolltop
import ReturnTopButton from '../../component/page_parts/common/scrolltop';

// パンくずリスト
import TableOfContents from "../../component/page_parts/common/table_of_contents";

function Keiri() {
  //各種申請用のstate
  const [jsonData_sinsei, setJsonData_sinsei] = useState([]);
  const [category_sinsei, setCategory_sinsei] = useState([]);

  //faq用のstate
  const [jsonData_faq, setJsonData_faq] = useState([]);
  const [category_faq, setCategory_faq] = useState([]);
  const [sliderImages, setSliderImages] = useState([]);
  const [sliderImages_sin, setSliderImages_sin] = useState([]);

  //マニュアル用のstate
  const [jsonData_manual, setJsonData_manual] = useState([]);

  //モーダル用のstate
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showModalIndex, setShowModalIndex] = useState(null);
  const [showModalIndex_sin, setShowModalIndex_sin] = useState(null);

  const jsonData = {
    categoryList: [
      "交通費精算",
      "経費精算",
      "出張精算",
      "海外出張精算",
      "交際費精算",
      "支払依頼",
      "領収書・請求書アップロード",
      "その他全般",
      "稟議書（汎用・購入・人事）",
      "連絡書",
      "契約・押印稟議",
      "SI業務依頼",
      "インボイス制度",
      "共通"
    ],
    contentList: [
      {
        "category": "留意点",
        "tag": "shinsei_add"
      },
      {
        "category": "マニュアル",
        "tag": "manual_add"
      },
      {
        "category": "FAQ",
        "tag": "faq_add"
      }
    ],
    sinsei_ryui: [
      {
        "category": "領収書・請求書アップロード",
        "text": "アップロードできるのはPDFデータのみで、PDFには色や文字の加工は行わないでください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "領収書・請求書アップロード",
        "text": "領収書/請求書をアップロードした際、取引日・受領日・取引先名・金額・インボイス事業者登録番号（T+13桁の数字）を自動で読み取りますが、その読み取りに誤りがある場合は手動で訂正してください。",
        "layout": "2",
        "fileName": "keiri_cms-receipt_invoice_q2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "領収書・請求書アップロード",
        "text": "受領した紙の領収書原本は、各種立替精算の申請後、プリントアウトした申請書の余白に貼り付けて経理課へ提出をお願いします。余白がない場合は、Ａ４用紙に貼り付けてください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "領収書・請求書アップロード",
        "text": "データで受領した請求書・領収書をアップロードする場合は「電子取引」を選択し、紙の領収書をアップロードした場合は「スキャナ保存」を選択してください。",
        "layout": "2",
        "fileName": "keiri_cms-receipt_invoice_q4.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "領収書・請求書アップロード",
        "text": "外貨建て領収書をアップロードした場合、日本円へ換算した額を手入力願います。換算方法は次のとおりです。\n・海外で現金払いの場合：両替時の為替レートで換算\n・クレジットカード払いの場合：カードの利用明細",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "交通費精算",
        "text": "交通費精算を初めて申請する場合、楽楽精算で定期区間登録が完了しているかの確認しましょう。\n（※）定期区間の登録確認方法\n①楽楽精算の右上の「個人設定」➡「定期区間」をクリック\n②登録している定期区間が表示されます。",
        "layout": "3",
        "fileName": "keiri_cms-transportation_expenses_q1-1.png | keiri_cms-transportation_expenses_q1-2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "交通費精算",
        "text": "交通費精算の申請時では、原則的に交通系ICカード読み取りによる申請、あるいは、「乗換案内」機能を使って申請しましょう。\n※「楽楽精算ICカードリーダー」アプリの取り込み準備は、交通費精算FAQ８をご確認ください。\n※交通系ICカード情報を利用して申請する方法は、交通費精算FAQ９をご確認ください。\n※「乗換案内」機能を使って申請する方法は、交通費精算FAQ１２をご確認ください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "交通費精算",
        "text": "ICカードに保存できる履歴データの上限件数は19件です。19件より前のデータは「楽楽精算」に取り込めないため、こまめに取り込み作業を行うことをおススメします。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "交通費精算",
        "text": "タクシーや新幹線など利用時の領収書は紛失しないように保管しましょう。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "出張精算",
        "text": "出張予定が決まり次第、出張申請前に、購入稟議申請を行ってください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "出張精算",
        "text": "出張申請の申請時に、定期区間が登録されているかを確認しましょう。\n\n（※）定期区間の登録確認方法\n①楽楽精算の右上の「個人設定」➡「定期区間」をクリック\n②登録している定期区間が表示されます。",
        "layout": "3",
        "fileName": "keiri_cms-business_trip_payment_q1-1.png | keiri_cms-business_trip_payment_q1-2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "出張精算",
        "text": "出張申請の申請時に、日当の登録を忘れる方が多いです！日当の登録を忘れずに申請しましょう！",
        "layout": "2",
        "fileName": "keiri_cms-business_trip_payment_q2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "出張精算",
        "text": "宿泊費の上限・日当は役職によって異なります。\n出張申請の申請時に表示される宿泊費上限や日当が正しいかどうかは、次の手順で確認できます。\n\n①出張申請時に自動で算出表示される宿泊費・日当を確認します。\n②国内出張旅費支給上限を確認し、正しいかどうかを確認します。",
        "layout": "3",
        "fileName": "keiri_cms-business_trip_payment_q3-1.png | keiri_cms-business_trip_payment_q3-2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "出張精算",
        "text": "出張期間中に、土日祝日等で就労が無い日の日当は、支給対象外です（出張旅費規程 第１章 第５条）。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "出張精算",
        "text": "出張時の手土産は、出張申請ではなく、別途、交際費申請を行ってください。\n\n申請の手順は次のとおりです。 \n①交際費申請画面にて、当社人数を１名、先方人数を1名に設定（人数の入力が必須のため）。\n②明細画面にて、支払予定額を記入・人数を１名へ変更・内訳を「取引先への謝礼・手土産」を選択して申請",
        "layout": "3",
        "fileName": "keiri_cms-business_trip_payment_q5-1.png | keiri_cms-business_trip_payment_q5-2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "海外出張精算",
        "text": "出張予定が決まり次第、出張申請前に、購入稟議申請を行ってください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "海外出張精算",
        "text": "宿泊費の上限・日当は役職によって異なります。\n出張申請の申請時に表示される宿泊費上限や日当が正しいかどうかは、次の手順で確認できます。\n①出張申請時に自動で算出表示される宿泊費・日当を確認します。\n②海外出張旅費支給上限を確認し、正しいかどうかを確認します。",
        "layout": "3",
        "fileName": "keiri_cms-overseas_business_trip_q1-1.png | keiri_cms-overseas_business_trip_q1-2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "海外出張精算",
        "text": "出張期間中に、土日祝日等で就労が無い日の日当は、支給対象外です（出張旅費規程 第１章 第５条）。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "海外出張精算",
        "text": "精算時の為替レートは両替時のレートを適用しますので、両替時のレシートは保管が必要です。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "海外出張精算",
        "text": "クレジットカードで支払った場合、実際に引き落とされる日本円にて精算しましょう。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "海外出張精算",
        "text": "出張時の手土産は、出張申請ではなく、別途、交際費申請を行ってください。\n\n申請の手順は次のとおりです。\n①交際費申請画面にて、当社人数を１名、先方人数を1名に設定（人数の入力が必須のため）。\n②明細画面にて、支払予定額を記入・人数を１名へ変更・内訳を「取引先への謝礼・手土産」を選択して申請",
        "layout": "3",
        "fileName": "keiri_cms-overseas_business_trip_q5-1.png | keiri_cms-overseas_business_trip_q5-2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "経費精算",
        "text": "税別 5,000円以上のものを立替購入する場合は、事前に経費申請が必要です。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "経費精算",
        "text": "経費申請/経費精算の申請時、明細画面の登録は、一番最初に負担部門を選択してから行いましょう。",
        "layout": "2",
        "fileName": "keiri_cms-calculation_of_expenses_q2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "支払依頼",
        "text": "支払依頼は、基本的に、購入稟議で購買を承認されたものを支払う場合に利用します。\n※国内の振込のみに対応しており、海外送金の場合は、連絡書を申請してください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "支払依頼",
        "text": "支払先は手入力ではなく、原則的に、以下の方法で支払先から選択します。\n①支払先の「▢コード入力する」にチェックを入れます。\n②その下の項目の🔍マークをクリックすると、支払先を選択する画面が表示されます。\n※支払先が見つからない場合は、経理課まで速やかにご連絡ください。",
        "layout": "3",
        "fileName": "keiri_cms-payment_request_q2-1.png | keiri_cms-payment_request_q2-2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "支払依頼",
        "text": "支払予定日には、翌月末日（最終営業日）が登録されているかを確認しましょう。急ぎの支払いなど翌月末払い以外の場合、経理課担当者まで共有してください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "支払依頼",
        "text": "「源泉税額計算」の選択は、請求書に税別費用が記載されていない場合、「消費税込み額×源泉税率」を選択します。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "支払依頼",
        "text": "支払依頼申請者の部門と、費用の負担部門が異なる場合は、支払依頼の明細内で負担部門を変更できます。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "交際費精算",
        "text": "当社人数と先方人数の記載が必須です。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "交際費精算",
        "text": "交際費精算は、交際費申請が事前に必須です。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "交際費精算",
        "text": "交際費精算の申請時に、飲食に参加した先方担当者の全員分のフルネームが必要になるため、先方担当者のフルネームを把握しておきましょう。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "交際費精算",
        "text": "取引先への手土産を購入する場合は、交際費申請を申請してください。申請方法は次の手順です。\n\n①交際費申請画面にて、当社人数を１名、先方人数を1名に設定してください（人数の入力が必須のため）。\n②明細画面にて、支払予定額を記入・人数を１名へ変更・内訳を「取引先への謝礼・手土産」を選択して申請してください。",
        "layout": "3",
        "fileName": "keiri_cms-entertainment_expenses_q4-1.png | keiri_cms-entertainment_expenses_q4-2.png",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "インボイス制度",
        "text": "インボイス制度が始まり、請求書・領収書やレシートに、インボイス事業者登録番号（T+13桁）の数字が記載されます。\n※購入先が免税事業者の場合は記載されていません。",
        "layout": "3",
        "fileName": "keiri_receipt.jpg | keiri_invoice.jpg",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "インボイス制度",
        "text": "請求書／領収書を楽楽精算へアップロードする際に、インボイス事業者登録番号が読み取られていることを確認のうえ、アップロードを完了してください。",
        "layout": "3",
        "fileName": "keiri_rakurakuSettlementApp.jpg | keiri_rakurakuSettlementPC.jpg",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "インボイス制度",
        "text": "インボイス制度は、買う側・売る側の両方に関わるので、従業員は基礎的な知識を備えておく必要があります。\nこちらの動画にて基本的なインボイス制度の概要を理解できますので、ご自身の業務にどのように関係してくるかを考えてみましょう。",
        "layout": "4",
        "fileName": "",
        "movieUrl": "https://www.youtube.com/embed/WgizyzfkRDM?si=gvxmAAh-H1AZtM40",
        "movieTitle": "インボイス制度セミナー"
      },
      {
        "category": "インボイス制度",
        "text": "インボイス制度の概要や留意点についてまんがでも紹介しております。\n動画と併せてごらんください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "インボイス制度",
        "text": "・導入",
        "layout": "3",
        "fileName": "keiri_introduction1.jpg | keiri_introduction2.jpg | keiri_introduction3.jpg",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "インボイス制度",
        "text": "・仕入税額控除",
        "layout": "3",
        "fileName": "keri_tax1.jpg | keri_tax2.jpg | keri_tax3.jpg | keri_tax4.jpg | keri_tax5.jpg | keri_tax6.jpg",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "インボイス制度",
        "text": "・Zenkenは登録事業者か否か",
        "layout": "3",
        "fileName": "keiri_issuer1.jpg | keiri_issuer2.jpg",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "インボイス制度",
        "text": "・非登録事業者とは",
        "layout": "3",
        "fileName": "keiri_non-registered1.jpg | keiri_non-registered2.jpg | keiri_non-registered3.jpg",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "インボイス制度",
        "text": "・取引しちゃいけない？",
        "layout": "2",
        "fileName": "keiri_transaction.jpg",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "経費精算",
        "text": "Amazonの個人アカウントで購入した場合、次の「Amazonのインボイス取得方法」を参考にして申請してください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      },
      {
        "category": "支払依頼",
        "text": "Amazon Business アカウントで購入した場合、次の「Amazon Businessのインボイス取得方法」を参考にして申請してください。",
        "layout": "1",
        "fileName": "なし",
        "movieUrl": "",
        "movieTitle": ""
      }
    ],
    faq: [
      {
        "id": "1",
        "category": "交通費精算",
        "question": "ログインパスワードにロックがかかってしまいました。どうすれば良いでしょうか？",
        "answer": "パスワードを忘れた場合は、総務にご連絡ください。対応後、パスワード設定メールが届きますので、パスワードの再設定をお願いいたします。",
        "layout": "1",
        "fileName": ""
      },
      {
        "id": "1",
        "category": "交通費精算",
        "question": "領収書を紛失した場合、立替精算はどのように対応すれば良いでしょうか？",
        "answer": "立替精算を申請する場合、公共交通機関以外では、原則的に領収書（あるいはレシート）が必要です。そのため、次のいずれかの方法で対応願います。\n① レシートや支払先からのメールなど、領収書の代わりとなるものがないかを確認してください。\n② 支払先に領収書の再発行を依頼してください。\n③ ①②の対応でも解決しない場合、経理課までご相談ください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "id": "1",
        "category": "交通費精算",
        "question": "領収書の日付に誤りがあった場合、どうすれば良いでしょうか？",
        "answer": "支払先へ訂正を依頼し、正しい内容の領収書を受領してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "id": "1",
        "category": "交通費精算",
        "question": "領収書の宛名が会社名ではなく自分の個人名になっていますが、このまま領収書をアップロードして立替精算の申請は可能でしょうか？",
        "answer": "はい、そのまま領収書をアップロードして、立替精算の申請を行ってください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "id": "1",
        "category": "交通費精算",
        "question": "楽楽精算で申請を行った後に、申請内容を修正したい場合はどうすればよいですか？",
        "answer": "承認依頼中の場合（最終承認が未完了の場合）、申請者が「取下げ」を行い修正してください。承認者から「差戻し」された場合も修正が可能です。\n\n①取り下げる申請の一覧をクリックします。\n②申請履歴より該当する申請書を選択します。\n③表示された申請画面左下に表示される「取下げ」ボタンをクリックします。\n\n※最終承認が完了している場合は「取下げ」「差戻し」はできないため、再申請を行ってください。また、最終承認者に再申請することを共有してください。",
        "layout": "3",
        "fileName": "keiri_faq-common_q5-1.png | keiri_faq-common_q5-2.jpg | keiri_faq-common_q5-3.jpg"
      },
      {
        "category": "交通費精算",
        "question": "申請済のものが不要になった場合、どうすれば良いでしょうか？",
        "answer": "承認依頼中の場合は、申請者が「取下げ」を行う、あるいは、承認者から「差戻し」を行ってください。\n\n最終承認まで完了している場合は、最終承認者へ不要になった旨をお知らせください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "交通費精算",
        "question": "申請を忘れた交通費や経費精算は、どの期間までさかのぼって申請できますか？",
        "answer": "まずは、経理課までご相談ください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "交通費精算",
        "question": "交通系ICカード情報を取り込むための準備手順を教えてください。",
        "answer": "①スマホに『楽楽精算ICカードリーダー』アプリをインストールします。\n②アプリ起動後、楽楽精算URL（https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/）を入力します。\n➡これで、交通系ICカード情報を、スマホで取り込む準備完了です。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "交通費精算",
        "question": "交通系ICカード情報を利用して交通費精算を行う方法を教えてください。",
        "answer": "①スマホで『楽楽精算ICリーダー』アプリを起動し、交通系ICカードをスマホにかざすと、ICカード情報が取り込まれます。\n②交通費精算の申請画面上の「ICカード」ボタンをクリックします。\n③精算する交通費項目をチェックして次へ進みます。\n④訪問先・目的・交通機関を入力し、「明細追加」ボタンをクリックしてください。",
        "layout": "3",
        "fileName": "keiri_faq-transportation_expenses_q2-1.png | keiri_faq-transportation_expenses_q2-2.png | keiri_faq-transportation_expenses_q2-3.png | keiri_faq-transportation_expenses_q2-4.png"
      },
      {
        "category": "交通費精算",
        "question": "交通系ICカードでタクシー料金を支払った場合、タクシーの利用履歴は表示されないのでしょうか？",
        "answer": "タクシーの履歴データは取り込まれません。そのため、必ず領収書を受け取り、紛失しないように気をつけてください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "交通費精算",
        "question": "交通系ICカード情報の取り込み時に、一部の履歴データが読み込めなかった場合、どうすればよいですか？",
        "answer": "交通費精算申請画面の明細内にある「乗換案内」を利用して、経路を登録してください。原則的に、料金の手入力はやめてください。\n\n※「ICカード自体に保存されている履歴データの上限件数」は19件です。そのため、19件より前のデータは「楽楽精算」にも取り込むことができないため、こまめに楽楽精算へのICカード情報の取り込み作業を行ってください。",
        "layout": "2",
        "fileName": "keiri_faq-transportation_expenses_q4.png"
      },
      {
        "category": "交通費精算",
        "question": "「乗換案内」を使った交通費精算方法を教えてください。",
        "answer": "①明細追加画面で、「出発」と「到着」に駅名を入力し、「乗換案内」ボタンをクリックします。\n②その区間の利用候補が表示されるので、利用したものを選択してください。\n※乗換案内を表示させてから、出発地と到着地を入力することも可能です。",
        "layout": "3",
        "fileName": "keiri_faq-transportation_expenses_q5-1.png | keiri_faq-transportation_expenses_q5-2.png"
      },
      {
        "category": "交通費精算",
        "question": "出張先での交通費は交通費精算で申請できますか？",
        "answer": "出張先で利用した交通費は、出張申請を申請したうえで、出張精算にて申請してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "交通費精算",
        "question": "テレワーク中のため定期を利用しておりませんが、取引先やオフィスへの交通費の立替が発生しました。この場合、交通費精算で注意すべき点はありますか？",
        "answer": "A.取引先など会社以外の場所への交通費は、交通費精算を行ってください。その際に、楽楽精算上で定期区間登録がされていないことを確認してください。定期区間登録されていると、定期代の支給を受けていない場合でも、登録されている区間の交通費が控除されてしまいます。\n\nなお、交通費精算画面の備考欄に、”テレワーク勤務の為、定期区間登録をせずに申請”と記載願います。\n\n➤定期区間の登録確認方法\n①楽楽精算トップページ右上の「個人設定」➡「定期区間」をクリック\n②登録している場合は、定期区間が表示されます。\n\nB．会社へ出勤する場合の交通費については、人事部へ確認のうえ、必要であれば交通費精算を申請してください。",
        "layout": "3",
        "fileName": "keiri_faq-transportation_expenses_q7-1.png | keiri_faq-transportation_expenses_q7-2.png"
      },
      {
        "category": "交通費精算",
        "question": "交通費精算、出張精算のどちらを申請すればよいのか分かりません。出張の明確な基準はありますか？",
        "answer": "勤務先各拠点から、半径100km以上の移動を要するものが出張となります。距離が分かりにくい場合は、Google Mapの”距離を測定”機能で計測してみてください。\n\n（参）出張旅費規程　第２章　第９条",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "出張精算",
        "question": "出張申請の申請時に、日当や宿泊費上限の額が正しくありませんでした。どうすれば良いでしょうか？",
        "answer": "楽楽精算上での役職が正しく登録されていない可能性があります。役職の登録内容の確認は、総務課・武藤マネージャーへ依頼してください。\n役職に応じた日当・宿泊費上限は、国内出張旅費支給上限（画像）をご確認ください。",
        "layout": "2",
        "fileName": "keiri_faq-business_trip_payment.png"
      },
      {
        "category": "出張精算",
        "question": "出張中に取引先との飲食代が発生した場合、飲食代の精算手続きはどのようにしたらよいですか？",
        "answer": "出張中に取引先との飲食が発生した場合、出張精算とは別に、交際費申請を申請・承認の上、交際費精算を申請して精算してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "出張精算",
        "question": "出張費の精算額が、申請額よりも大きくなってしまいました。この場合、どのような対応が必要でしょうか？",
        "answer": "次のいずれかの方法で対応してください。\n①再度、出張申請を申請し、出張精算を申請する。その際、備考欄に、再申請である旨と、最初に申請した出張申請Noを記入してください。\n②追加分の出張費用に関して出張申請を申請し、出張精算を申請してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "出張精算",
        "question": "出張時の不測の事態に備え、予算をあらかじめ十分に申請する方法はありますか？",
        "answer": "想定される費用について、出張申請の申請時に明細を追加して申請してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "海外出張精算",
        "question": "精算時の為替レートは、どの時点の為替レートが適用されますでしょうか？",
        "answer": "両替時の為替レートを適用します。両替時に受領するレシートや証明書は捨てずに保管しておきましょう。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "海外出張精算",
        "question": "両替時のレシートを紛失した場合、どのように対応すれば良いでしょうか？",
        "answer": "経理課までご相談ください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "海外出張精算",
        "question": "この度の出張で、取引先への手土産や飲食費の交際費が発生する予定ですが、出張申請でまとめて申請できますか？",
        "answer": "まとめて申請はできません。\n手土産は、交際費申請より別途申請してください。\n\n申請の手順は次の方法で行ってください。\n①交際費申請画面にて、当社人数を１名、先方人数を1名に設定してください（人数の入力が必須のため）。\n②明細画面にて、支払予定額を記入・人数を１名へ変更・内訳を「取引先への謝礼・手土産」を選択して申請してください。",
        "layout": "3",
        "fileName": "keiri_faq-overseas_business_trip_q3-1.png | keiri_faq-overseas_business_trip_q3-2.png"
      },
      {
        "category": "海外出張精算",
        "question": "出張費の精算額が、申請額よりも大きくなってしまいました。この場合、どのような対応が必要でしょうか？",
        "answer": "次のいずれかの方法で対応してください。\n①再度、出張申請を申請し、出張精算を申請する。その際、備考欄に、再申請である旨と、最初に申請した出張申請Noを記入してください。\n②追加分の出張費用に関して出張申請を申請し、出張精算を申請してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "海外出張精算",
        "question": "出張時の不測の事態に備え、予算をあらかじめ十分に申請する方法はありますか？",
        "answer": "想定される費用について、出張申請の申請時に明細を追加して申請してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "経費精算",
        "question": "購入したものに該当する品目が分からない時はどうすれば良いでしょうか？",
        "answer": "経理課までチャットにてお問い合わせください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "経費精算",
        "question": "費用の負担部門を、私が所属する部門以外に設定するにはどうすれば良いですか？",
        "answer": "明細画面の負担部門の内容を、所属する部門から負担する部門へ変更してください。",
        "layout": "2",
        "fileName": "keiri_faq-calculation_of_expenses_q2.png"
      },
      {
        "category": "経費精算",
        "question": "購入稟議で申請したものを、立替で支払いました。この場合、経費申請は必要でしょうか？",
        "answer": "購入稟議を申請している場合は、経費申請は不要です。　　　　　　　　　　　　　　　\n経費精算の申請では、経費申請だけでなく、購入稟議も紐づけることが可能です。\nもし、購入稟議の申請者が他社員の方の場合は、経費申請を行ったうえで、経費精算を行ってください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "経費精算",
        "question": "経費申請か購入稟議のどちらを申請すべきか分かりません。この場合、どうすれば良いでしょうか？",
        "answer": "判断がつかない場合は、購入稟議を申請してください。　　　　　　　　　　　　　　　\n経費精算の申請では、経費申請と購入稟議のどちらかを紐づけることが可能ですが、支払依頼では、経費申請を紐づけることができません。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "経費精算",
        "question": "毎月、同じような経費精算を申請しています（例：毎月切手を立替で購入）。過去の申請をコピーして申請することは可能でしょうか？",
        "answer": "はい、可能です。次の流れで対応してください。\n①過去の申請一覧から該当する立替精算を選択します。\n②選択した過去の申請画面の「コピー」ボタンをクリックします。\n③コピーができた後は、”エンピツ”マークをクリックして、明細画面にて領収書を添付してください。",
        "layout": "3",
        "fileName": "keiri_faq-calculation_of_expenses_q5-1.png | keiri_faq-calculation_of_expenses_q5-2.png | keiri_faq-calculation_of_expenses_q5-3.png"
      },
      {
        "category": "支払依頼",
        "question": "支払先の一覧に、支払先の情報が登録されていません。どうすれば良いでしょうか？",
        "answer": "経理課の担当者へチャットにてお問い合わせください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "支払依頼",
        "question": "他の人が申請した購入稟議書を、支払依頼申請時に紐づけることができません。どうすれば良いでしょうか？",
        "answer": "購入稟議申請者へ、代理申請者としてあなたを登録するように依頼してください。\n\n代理申請者の登録方法は次のとおりです。\n・楽楽精算画面の右上にある「個人設定」➡「設定」➡代理申請者設定へ登録",
        "layout": "2",
        "fileName": "keiri_faq-payment_request_q2.png"
      },
      {
        "category": "支払依頼",
        "question": "他の人がアップロードした請求書を選択することができません。どうすれば良いでしょうか？",
        "answer": "支払依頼を申請する人が、請求書のアップロードを行ってください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "支払依頼",
        "question": "エラー：「金額が、請求書の金額と一致しません」が表示されます。どうすれば良いでしょうか。",
        "answer": "請求書をアップロードした際に、自動で読み取られた請求額に誤りがあることが原因です。アップロードした請求書情報を、手入力で修正してください。",
        "layout": "2",
        "fileName": "keiri_faq-payment_request_q4.png"
      },
      {
        "category": "支払依頼",
        "question": "エラー:「●●は支払依頼では利用できない内訳です。」が表示されました。対応方法を教えてください。",
        "answer": "支払依頼の明細画面にて、負担部門を選択してから品目（内訳）を選択していただくと、このエラーは発生しません。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "支払依頼",
        "question": "源泉税額計算のどちらを選択すれば良いか分かりません。",
        "answer": "請求書に税別合計額が記載されている場合は、「消費税抜き額✕源泉税率」を選択してください。\n税込額合計の記載のみの場合は、「消費税込み額×源泉税率」を選択してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "支払依頼",
        "question": "１つの請求書の中で、複数の内容が含まれている場合（例：負担部門が複数ある、品目が複数ある）、どのように申請すれば良いでしょうか？",
        "answer": "支払依頼を申請する際に、複数の内容に合わせて明細登録を分けてください。\n例）部門で分ける　明細① VI営業負担 20,000円　②VI制作負担 10,000円\n例）品目で分ける　明細① 運用費原価 15,000円　②販売促進費 15,000円\n\n※上記のように１つの請求書に基づく支払依頼で、複数の明細を登録する場合、請求書のアップロードの時点で、その明細登録に合わせて金額を分けてアップロードすることが必要です。金額を分けて請求書/領収書をアップロードする方法は、”領収書/請求書のアップロード”のQ.4をご確認ください。",
        "layout": "2",
        "fileName": "keiri_faq-payment_request_q7.png"
      },
      {
        "category": "支払依頼",
        "question": "スマホから支払依頼の申請はできませんか？",
        "answer": "スマホからの申請はできません。スマホで申請できるのは、立替精算のみです。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "支払依頼",
        "question": "海外への送金が必要になる場合は、どうすれば良いでしょうか？",
        "answer": "購入稟議承認後、連絡書にて海外送金の依頼を行ってください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "交際費精算",
        "question": "交際費の申請は、どのような場合に申請しますか？",
        "answer": "次の場合は、必ず交際費の申請を行ってください。\n・取引先など社外の方との会食で、一人当たり2,000円（税別）を超える場合\n\n※一人当たり税別2,000円以下のランチやカフェミーティング等の場合、経費精算を申請してください。購入品目は「打合せ（会議費）」を選択します。\n※立替総額が5,000円（税別）を超える場合は、経費申請を行ってください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "交際費精算",
        "question": "取引先とのランチミーティングを行いました。この場合は交際費申請が必要でしょうか？",
        "answer": "①カフェやランチミーティングなどで、一人当たり税別2,000円以下の場合は、経費精算を申請してください（品目は「打合せ（会議費）」）。立替総額が5,000円（税別）を超える場合は、経費申請承認後に、経費精算を申請してください。\n②一人あたり税別2,000円を超える場合は、交際費申請を行ったうえで、交際費精算を申請してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "領収書・請求書アップロード",
        "question": "エラー「タイムスタンプを付与することができませんでした。」が表示されてアップロードできない場合、どうすれば良いですか？",
        "answer": "PDFのパスワードの解除ができない場合は、\n一度開いたPDFを再保存するなどして、改めてアップロードをお試しください。\n\n▽手順　\n　　1. PDFを開き、Ctrl＋Pキー等で印刷メニューを表示する。\n　　2. プリンターに「Microsoft Print to PDF」もしくは「PDFに保存」を選択し、\n　　　別のPDFファイルとして保存する。\n　　3.  2.の手順で作成した別PDFをアップロードする。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "領収書・請求書アップロード",
        "question": "エラー「パスワードで保護されたファイルは登録できません」と表示されアップロードできないのですが、どうすれば良いですか？",
        "answer": "PDFのパスワードの解除ができない場合は、\n一度開いたPDFを再保存するなどして、改めてアップロードをお試しください。\n（Q１と同じ回答です）\n\n▽手順　\n　　1. PDFを開き、Ctrl＋Pキー等で印刷メニューを表示する。\n　　2. プリンターに「Microsoft Print to PDF」もしくは「PDFに保存」を選択し、\n　　　別のPDFファイルとして保存する。\n　　3.  2.の手順で作成した別PDFをアップロードする。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "領収書・請求書アップロード",
        "question": "請求書がなく、代わりにメール文面が請求書の場合は、どのようにアップロードすればよいですか？",
        "answer": "請求内容が記載されたメール文面全てをPDFで保存し、アップロードしてください。請求部分のみをPDFにしてアップロードすることはやめてください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "領収書・請求書アップロード",
        "question": "１件の請求書・領収書のアップロード時に、合計金額を分けて登録する方法を教えてください？",
        "answer": "次の流れで登録してください。\n①請求書をアップロードし、「＋」ボタンで金額を分ける項目を追加します。\n②請求合計額を内容に合わせて分割し、確定をクリックして登録完了です。",
        "layout": "3",
        "fileName": "keiri_faq-receipt_invoice_q4-1.png | keiri_faq-receipt_invoice_q4-2.png"
      },
      {
        "category": "領収書・請求書アップロード",
        "question": "クレジットカードの明細は領収書の代わりになるでしょうか？",
        "answer": "クレジットカード明細は領収書の代わりとなりませんので、領収書をアップロードしてください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "共通",
        "question": "ログインパスワードにロックがかかってしまいました。どうすれば良いでしょうか？",
        "answer": "パスワードを忘れた場合は、総務にご連絡ください。対応後、パスワード設定メールが届きますので、パスワードの再設定をお願いいたします。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "共通",
        "question": "領収書を紛失した場合、立替精算はどのように対応すれば良いでしょうか？",
        "answer": "立替精算を申請する場合、公共交通機関以外では、原則的に領収書（あるいはレシート）が必要です。そのため、次のいずれかの方法で対応願います。\n① レシートや支払先からのメールなど、領収書の代わりとなるものがないかを確認してください。\n② 支払先に領収書の再発行を依頼してください。\n③ ①②の対応でも解決しない場合、経理課までご相談ください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "共通",
        "question": "領収書の日付に誤りがあった場合、どうすれば良いでしょうか？",
        "answer": "支払先へ訂正を依頼し、正しい内容の領収書を受領してください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "共通",
        "question": "領収書の宛名が会社名ではなく自分の個人名になっていますが、このまま領収書をアップロードして立替精算の申請は可能でしょうか？",
        "answer": "はい、そのまま領収書をアップロードして、立替精算の申請を行ってください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "共通",
        "question": "楽楽精算で申請を行った後に、申請内容を修正したい場合はどうすればよいですか？",
        "answer": "承認依頼中の場合（最終承認が未完了の場合）、申請者が「取下げ」を行い修正してください。承認者から「差戻し」された場合も修正が可能です。\n\n①取り下げる申請の一覧をクリックします。\n②申請履歴より該当する申請書を選択します。\n③表示された申請画面左下に表示される「取下げ」ボタンをクリックします。\n\n※最終承認が完了している場合は「取下げ」「差戻し」はできないため、再申請を行ってください。また、最終承認者に再申請することを共有してください。",
        "layout": "2",
        "fileName": "keiri_faq-common_q5-1.png"
      },
      {
        "category": "共通",
        "question": "申請済のものが不要になった場合、どうすれば良いでしょうか？",
        "answer": "承認依頼中の場合は、申請者が「取下げ」を行う、あるいは、承認者から「差戻し」を行ってください。\n\n最終承認まで完了している場合は、最終承認者へ不要になった旨をお知らせください。",
        "layout": "1",
        "fileName": ""
      },
      {
        "category": "共通",
        "question": "申請を忘れた交通費や経費精算は、どの期間までさかのぼって申請できますか？",
        "answer": "まずは、経理課までご相談ください。",
        "layout": "1",
        "fileName": ""
      }
    ],
    manual: [
      {
        "category": "領収書・請求書アップロード",
        "text": "",
        "fileName": "keiri_manual-receipt_upload.pdf",
        "fileName_jp": "（スマホ）アップロードの方法"
      },
      {
        "category": "領収書・請求書アップロード",
        "text": "",
        "fileName": "keiri_manual-receipt_upload_pc.pdf",
        "fileName_jp": "（PC）アップロードの方法"
      },
      {
        "category": "支払依頼",
        "text": "",
        "fileName": "keiri_manual-payment_request.pdf",
        "fileName_jp": "マニュアルダウンロード"
      },
      {
        "category": "交通費精算",
        "text": "",
        "fileName": "keiri_manual-transportation_expense_settlement.pdf",
        "fileName_jp": "交通費精算マニュアル"
      },
      {
        "category": "交通費精算",
        "text": "",
        "fileName": "keiri_manual-transit.pdf",
        "fileName_jp": "乗換案内の使い方"
      },
      {
        "category": "支払依頼",
        "text": "",
        "fileName": "keiri_manual-entertainment_expenses.pdf",
        "fileName_jp": "マニュアルダウンロード"
      },
      {
        "category": "交際費精算",
        "text": "",
        "fileName": "keiri_manual-calculation_of_expenses.pdf",
        "fileName_jp": "マニュアルダウンロード"
      },
      {
        "category": "経費精算",
        "text": "",
        "fileName": "",
        "fileName_jp": "経費申請・精算マニュアル"
      },
      {
        "category": "経費精算",
        "text": "",
        "fileName": "",
        "fileName_jp": "Amazon 利用時のインボイス対応"
      }
    ],
    content: [
      {
        "category": "領収書・請求書アップロード",
        "text": "",
        "fileName": "keiri_manual-receipt_upload.pdf",
        "fileName_jp": "（スマホ）アップロードの方法"
      },
      {
        "category": "領収書・請求書アップロード",
        "text": "",
        "fileName": "keiri_manual-receipt_upload_pc.pdf",
        "fileName_jp": "（PC）アップロードの方法"
      },
      {
        "category": "支払依頼",
        "text": "",
        "fileName": "keiri_manual-payment_request.pdf",
        "fileName_jp": "マニュアルダウンロード"
      },
      {
        "category": "交通費精算",
        "text": "",
        "fileName": "keiri_manual-transportation_expense_settlement.pdf",
        "fileName_jp": "交通費精算マニュアル"
      },
      {
        "category": "交通費精算",
        "text": "",
        "fileName": "keiri_manual-transit.pdf",
        "fileName_jp": "乗換案内の使い方"
      },
      {
        "category": "支払依頼",
        "text": "",
        "fileName": "keiri_manual-entertainment_expenses.pdf",
        "fileName_jp": "マニュアルダウンロード"
      },
      {
        "category": "交際費精算",
        "text": "",
        "fileName": "keiri_manual-calculation_of_expenses.pdf",
        "fileName_jp": "マニュアルダウンロード"
      },
      {
        "category": "経費精算",
        "text": "",
        "fileName": "",
        "fileName_jp": "経費申請・精算マニュアル"
      },
      {
        "category": "経費精算",
        "text": "",
        "fileName": "",
        "fileName_jp": "Amazon 利用時のインボイス対応"
      }
    ]
  };

  //スライダーの設定
  const settings = {
    dots: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    swipe: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  const baseUrl = process.env.REACT_APP_PUBLIC_URL;

  useEffect(() => {
    const json = [jsonData];
    sinsei_ryui(json);
    manual(json);
    faq(json);
  }, []);

  //各種申請描画用の関数
  const sinsei_ryui = (json) => {
    var json1 = json[0].sinsei_ryui;
    // console.log(json1);
    var sliderObject = [];
    //jsonのfileNameが「|」区切りになっているものを探す
    for (let i = 0; i < json1.length; i++) {
      if (json1[i].fileName.includes('|')) {
        //「|」区切りになっているものを配列に変換
        var fileName = json1[i].fileName.split('|');

        //スペースを削除
        for (let j = 0; j < fileName.length; j++) {
          fileName[j] = fileName[j].replace(/\s+/g, '');
        }

        //質問をキーに、画像名を配列に格納
        sliderObject.push({
          question: json1[i].text,
          fileName: fileName,
        });
      }
    }
    // console.log(sliderObject);
    //スライダーに表示する画像をstateに格納
    setSliderImages_sin(sliderObject);

    // cosple.jog(json[0].sinsei_ryu);
    // カテゴリーを取り出し、重複を削除
    var category_value = json[0].sinsei_ryui
      .map((json) => json.category)
      .filter((x, i, self) => self.indexOf(x) === i);
    //カテゴリーをstateに格納
    setCategory_sinsei(category_value);

    //jsonをstateに格納
    setJsonData_sinsei(json[0].sinsei_ryui);
  };

  //マニュアル描画用の関数
  const manual = (json) => {
    // console.log(json[0].manual);
    //jsonをstateに格納
    setJsonData_manual(json[0].manual);
    // console.log(json[0].manual);
  };

  //FAQ描画用の関数
  const faq = (json) => {
    /*やりたいこと
     *jsonからcategoryを取り出す
     *カテゴリーをキーにして、ソートして、jsonを分ける
     *分けたjsonを表示する
     */
    //jsonのキーがfaqのものを取り出す
    var json = json[0].faq;
    var sliderObject = [];
    //jsonのfileNameが「|」区切りになっているものを探す
    for (let i = 0; i < json.length; i++) {
      if (json[i].fileName.includes('|')) {
        //「|」区切りになっているものを配列に変換
        var fileName = json[i].fileName.split('|');

        //スペースを削除
        for (let j = 0; j < fileName.length; j++) {
          fileName[j] = fileName[j].replace(/\s+/g, '');
        }

        //質問をキーに、画像名を配列に格納
        sliderObject.push({
          question: json[i].question,
          fileName: fileName,
        });
      }
    }
    // console.log(sliderObject);
    //スライダーに表示する画像をstateに格納
    setSliderImages(sliderObject);
    //カテゴリーを取り出す
    var category_value = json.map((json) => json.category);
    // console.log(category_value);
    //重複を削除
    var category_value_unique = category_value.filter(
      (x, i, self) => self.indexOf(x) === i
    );
    //重複を削除したカテゴリーをstateに格納
    setCategory_faq(category_value_unique);
    // console.log(category_value_unique);

    var json_sort = [];
    //カテゴリーの数だけfor文を回す
    for (let i = 0; i < category_value_unique.length; i++) {
      //カテゴリーをキーにして、jsonを分ける
      var json_category = json.filter(
        (json) => json.category === category_value_unique[i]
      );
      //カテゴリーごとに分けたjsonを配列に格納
      json_sort.push(json_category);
    }
    //カテゴリーごとに分けた配列をstateに格納
    setJsonData_faq(json_sort);
  };

  var bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  var content = 'あいうえお,かきくけこ,さしすせそ';
  var blob = new Blob([bom, content], { type: 'text/csv' });

  return (
    <>
      <Helmet>
        <title>Z-link 経費関連</title>
      </Helmet>
      <Header />
      <div className='theme-keiri theme-keiri-top'>
        <div className='content-header'>
          <div className='container'>
            <Row>
              <Col sm={9} className='pe-1'>
                <h1 className='page-title type-pig'>経費関連（楽楽精算）</h1>
                {/* ページタイトル */}
                <p className='page-description'>
                  交通費精算、出張精算、振込依頼など経費関連の各種申請は全て「楽楽精算」にて
                </p>
                {/* ページの説明 */}
              </Col>
              <Col sm={3} className='btn-wrap d-flex align-self-end'>
                <a
                  href='https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/'
                  className='btn-link-area rakuraku__link position-fixed'
                  target='_blank'
                >
                  利用する
                </a>
                {/* ページタイトルの横にコンテンツがある場合はこちらに記入 */}
                <a
                  href={baseUrl + '/keiri/start_guide'}
                  className='link-to-start_guide'
                >
                  利用開始案内
                </a>
              </Col>
            </Row>
          </div>
        </div>
        <TableOfContents />

        <Container className='contents-wrap mt-5'>
          <section className='main mb-5'>
            <div>
              <h2 className='tag-title'>経費の各種事前チェック項目！</h2>
              <Tabs>
                <TabList>
                  {category_sinsei.map((category, index) => (
                    <Tab key={index}>{category}</Tab>
                  ))}
                </TabList>

                {category_sinsei.map((category, index) => (
                  <TabPanel key={index}>
                    <ol className={category === 'インボイス制度' ? 'ol--invoice' : undefined}>
                      {jsonData_sinsei.map((json, i) =>
                        json.category === category ? (
                          <li key={i} className='react-tabs__text'>
                            {
                              //改行コードを反映
                              json.text.split('\n').map((line, index) => {
                                if (
                                  json.text.split('\n').length - 1 !==
                                  index
                                ) {
                                  // 最後の要素以外
                                  return (
                                    <span key={index}>
                                      {line}
                                      <br />
                                    </span>
                                  );
                                } else {
                                  // 最後の要素の場合、末尾に<br>は入れない
                                  if (
                                    (json.fileName !== '' &&
                                      json.layout != '3') ||
                                    (json.fileName !== '' && json.layout == '3')
                                  ) {
                                    // 画像アイコンがつく場合、余白用にspan追加
                                    return (
                                      <span key={index} className='add-img-icon'>
                                        {line}
                                      </span>
                                    );
                                  } else {
                                    return <span key={index}>{line}</span>;
                                  }
                                }
                              })
                            }
                            {
                              //画像がある場合(画像1枚)
                              json.fileName !== '' && json.layout == '2' ? (
                                <>
                                  <button
                                    className={
                                      'btn p-0 jsonData_tatekae_ryui' + i
                                    }
                                    variant='secondary'
                                    onClick={() =>
                                      setShowModalIndex(
                                        'jsonData_tatekae_ryui' + i
                                      )
                                    }
                                  >
                                    <img
                                      className='react-tabs__icon'
                                      src={
                                        process.env.PUBLIC_URL +
                                        '/keiri_pic/icon-camera.png'
                                      }
                                      alt='画像モーダル起動ボタン'
                                      width='84'
                                      height='23'
                                      loading='lazy'
                                    />
                                  </button>

                                  <Modal
                                    show={
                                      showModalIndex ===
                                      'jsonData_tatekae_ryui' + i
                                    }
                                    onHide={() => setShowModalIndex(null)}
                                    className='keiri-modal'
                                    size='lg'
                                    centered
                                    scrollable
                                  >
                                    <Modal.Header closeButton>
                                      <Modal.Title>
                                        {' '}
                                        {
                                          //改行コードを反映
                                          json.text.split('\n').map((line, index) => {
                                            return (
                                              <span key={index}>
                                                {line}
                                                <br />
                                              </span>
                                            );
                                          })
                                        }
                                      </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      <img
                                        src={
                                          process.env.REACT_APP_SITE_URL +
                                          '/keiri_pic/' +
                                          json.fileName
                                        }
                                        alt='img'
                                      />
                                    </Modal.Body>
                                  </Modal>
                                </>
                              ) : (
                                <></>
                              )
                            }
                            {
                              //モーダルのレイアウトが3の場合(画像複数)
                              json.fileName !== '' && json.layout == '3' ? (
                                <>
                                  <button
                                    className={`btn p-0 ${json.category + i}`}
                                    variant='secondary'
                                    onClick={() =>
                                      setShowModalIndex_sin(json.category + i)
                                    }
                                  >
                                    <img
                                      className='react-tabs__icon'
                                      src={
                                        process.env.PUBLIC_URL +
                                        '/keiri_pic/icon-camera.png'
                                      }
                                      alt='画像モーダル起動ボタン hogehoge'
                                      width='84'
                                      height='23'
                                      loading='lazy'
                                    />
                                  </button>
                                  <Modal
                                    show={
                                      showModalIndex_sin === json.category + i
                                    }
                                    onHide={() => setShowModalIndex_sin(null)}
                                    className='keiri-modal'
                                    size='lg'
                                    centered
                                  >
                                    <Modal.Header closeButton>
                                      <Modal.Title>
                                        {
                                          //改行コードを反映
                                          json.text.split('\n').map((line, index) => {
                                            return (
                                              <span key={index}>
                                                {line}
                                                <br />
                                              </span>
                                            );
                                          })
                                        }
                                      </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      {sliderImages_sin.map((sliderImage, indev) => (
                                        <Slider {...settings} key={sliderImage.question || index}>
                                          {sliderImage.question ===
                                            json.text ? (
                                            sliderImage.fileName.map(
                                              (fileName, i) => (
                                                <div key={i}>
                                                  <img
                                                    src={
                                                      process.env
                                                        .REACT_APP_SITE_URL +
                                                      '/keiri_pic/' +
                                                      fileName
                                                    }
                                                    alt='img'
                                                    style={{
                                                      display: 'block',
                                                      margin: 'auto',
                                                    }}
                                                  />
                                                </div>
                                              )
                                            )
                                          ) : (
                                            <></>
                                          )}
                                        </Slider>
                                      ))}
                                    </Modal.Body>
                                  </Modal>
                                </>
                              ) : (
                                <></>
                              )
                            }
                            {
                              //モーダルのレイアウトが4の場合
                              json.layout == '4' && json.movieUrl != '' ? (
                                <>
                                  <Col
                                    sm={3}
                                    className='d-flex align-bottom align-self-end mb-3'
                                    id='keiri-movie'
                                  >
                                    <Button
                                      className='btn main-btn type-movie'
                                      variant='primary'
                                      onClick={() =>
                                        setShowModalIndex_sin(json.category + i)
                                      }
                                    >
                                      {json.movieTitle}
                                    </Button>
                                    <Modal
                                      show={
                                        showModalIndex_sin === json.category + i
                                      }
                                      onHide={() => setShowModalIndex_sin(null)}
                                      className='keiri-modal movie'
                                      size='lg'
                                      centered
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title>
                                          {
                                            //改行コードを反映
                                            json.text
                                              .split('\n')
                                              .map((line, index) => {
                                                return (
                                                  <span key={index}>
                                                    {line}
                                                    <br />
                                                  </span>
                                                );
                                              })
                                          }
                                        </Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        <div>
                                          <iframe
                                            width='1280'
                                            height='720'
                                            src={json.movieUrl}
                                            title={json.movieTitle}
                                            frameborder='0'
                                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                                            allowfullscreen
                                            className='keiri-movie'
                                          ></iframe>
                                        </div>
                                      </Modal.Body>
                                    </Modal>
                                  </Col>
                                </>
                              ) : (
                                <></>
                              )
                            }
                          </li>
                        ) : (
                          <></>
                        )
                      )}
                    </ol>
                    <div className='react-tabs__bottom d-flex justify-content-start mt-4'>
                      {jsonData_manual.map((json, index) =>
                        json.category === category ? (
                          <button key={index}
                            className='react-tabs__manual'
                            onClick={() =>
                              download(
                                process.env.PUBLIC_URL +
                                '/keiri_pic/' +
                                json.fileName
                              )
                            }
                          >
                            {json.fileName_jp}
                          </button>
                        ) : (
                          <></>
                        )
                      )}

                      <div className='keiri-link-btn'>
                        {category_faq.map((cate, index) => (
                          <>
                            {cate == category ? (
                              <Link
                                to={'cateID-' + index}
                                smooth={true}
                                duration={500}
                                offset={-100}
                                key={category}
                              >
                                {category}のFAQへ
                              </Link>
                            ) : (
                              <></>
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  </TabPanel>
                ))}
              </Tabs>
            </div>
          </section>
          <section className='faq'>
            <div className='contents'>
              <h2 className='tag-title mb-5' id='faq'>
                FAQ どんなことでお困りでしょうか？
              </h2>
              {/* <Search /> */}
            </div>
            <Row className='contents__tab'>
              {category_faq.map((cate, i) => (
                <Col key={i} sm={3} className='contents__tab-btn'>
                  <Link
                    className='btn main-btn type-internal down-link-btn col-sm-3'
                    to={'cateID-' + i}
                    smooth={true}
                    duration={500}
                    offset={-100}
                  >
                    {cate}
                  </Link>
                </Col>
              ))}
            </Row>
            {category_faq.map((cate, i) => (
              <div className='contents__box' id={'cateID-' + i}>
                <h3 className='icon-title type-pencil mt-small'>{cate}</h3>
                <Accordion alwaysOpen flush>
                  {jsonData_faq.map((json) =>
                    json.map((json, index) => {
                      return (
                        <>
                          {json.category === cate ? (
                            <Accordion.Item
                              key={index}
                              eventKey={index}
                              className='contents__qa border-0'
                            >
                              <Accordion.Header
                                className='contents__qa--question'
                                as='p'
                              >
                                {json.question}
                              </Accordion.Header>
                              <Accordion.Body>
                                <p className='contents__qa--answer'>
                                  {
                                    //改行コードを反映
                                    json.answer.split('\n').map((line, index) => {
                                      return (
                                        <span key={index}>
                                          {line}
                                          <br />
                                        </span>
                                      );
                                    })
                                  }
                                </p>
                                {
                                  /**jsonに画像があり、レイアウトが3でない場合*/
                                  json.fileName !== '' && json.layout != '3' ? (
                                    <>
                                      <Button
                                        className='btn-camera'
                                        variant='secondary'
                                        onClick={() =>
                                          setShowModalIndex(
                                            json.category + index
                                          )
                                        }
                                      >
                                        <img
                                          src={
                                            process.env.PUBLIC_URL +
                                            '/keiri_pic/icon-camera.png'
                                          }
                                          alt='画像モーダル起動ボタン'
                                          width='84'
                                          height='23'
                                          loading='lazy'
                                        />
                                      </Button>
                                      <Modal
                                        show={
                                          showModalIndex ===
                                          json.category + index
                                        }
                                        onHide={() => setShowModalIndex(null)}
                                        className='keiri-modal'
                                        size='lg'
                                        centered
                                        scrollable
                                      >
                                        <Modal.Header closeButton>
                                          <Modal.Title>
                                            A.
                                            {
                                              //改行コードを反映
                                              json.answer
                                                .split('\n')
                                                .map((line) => {
                                                  return (
                                                    <>
                                                      {line}
                                                      <br />
                                                    </>
                                                  );
                                                })
                                            }
                                          </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          <img
                                            id={json.id}
                                            src={
                                              process.env.REACT_APP_SITE_URL +
                                              '/keiri_pic/' +
                                              json.fileName
                                            }
                                            alt='img'
                                            style={{
                                              display: 'block',
                                              margin: 'auto',
                                            }}
                                          />
                                        </Modal.Body>
                                      </Modal>
                                    </>
                                  ) : (
                                    <></>
                                  )
                                }
                                {
                                  /**jsonに画像があり、レイアウトが3の場合*/
                                  json.fileName !== '' && json.layout == '3' ? (
                                    <div>
                                      <Button
                                        className='btn-camera'
                                        variant='primary'
                                        onClick={() =>
                                          setShowModalIndex(
                                            json.category + index
                                          )
                                        }
                                      >
                                        <img
                                          src={
                                            process.env.PUBLIC_URL +
                                            '/keiri_pic/icon-camera.png'
                                          }
                                          alt='画像モーダル起動ボタン'
                                          width='84'
                                          height='23'
                                          loading='lazy'
                                        />
                                      </Button>
                                      <Modal
                                        show={
                                          showModalIndex ===
                                          json.category + index
                                        }
                                        onHide={() => setShowModalIndex(null)}
                                        className='keiri-modal'
                                        size='lg'
                                        centered
                                      >
                                        <Modal.Header closeButton>
                                          <Modal.Title>
                                            A.
                                            {
                                              //改行コードを反映
                                              json.answer
                                                .split('\n')
                                                .map((line) => {
                                                  return (
                                                    <>
                                                      {line}
                                                      <br />
                                                    </>
                                                  );
                                                })
                                            }
                                          </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          {sliderImages.map((sliderImage) => (
                                            <Slider {...settings} key={sliderImage.question || index}>
                                              {sliderImage.question ===
                                                json.question ? (
                                                sliderImage.fileName.map(
                                                  (fileName, i) => (
                                                    <div key={i}>
                                                      <img
                                                        src={
                                                          process.env
                                                            .REACT_APP_SITE_URL +
                                                          '/keiri_pic/' +
                                                          fileName
                                                        }
                                                        alt='img'
                                                        style={{
                                                          display: 'block',
                                                          margin: 'auto',
                                                        }}
                                                      />
                                                    </div>
                                                  )
                                                )
                                              ) : (
                                                <></>
                                              )}
                                            </Slider>
                                          ))}
                                        </Modal.Body>
                                      </Modal>
                                    </div>
                                  ) : (
                                    <></>
                                  )
                                }
                              </Accordion.Body>
                            </Accordion.Item>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })
                  )}
                </Accordion>
              </div>
            ))}
          </section>
        </Container>
      </div >
      {/* <ReturnTopButton /> */}
      < Footer />
    </>
  );
}

export default Keiri;
